'use client';

import { createContext, ReactNode, useEffect } from 'react';

import { amplitudeApiKey } from '@/utils/constants';

import { init, track } from '@amplitude/analytics-browser';

interface AmplitudeContextType {
    trackAmplitudeEvent: (eventName: string, eventProperties?: Record<string, string>) => void;
}

export const AmplitudeContext = createContext<AmplitudeContextType | undefined>(undefined);

const trackAmplitudeEvent = (eventName: string, eventProperties?: Record<string, string>) => {
    track(eventName, eventProperties);
};

const AmplitudeContextProvider = ({ children }: { children: ReactNode }) => {
    useEffect(() => {
        init(amplitudeApiKey, {
            autocapture: {
                sessions: true,
            },
        });
    }, []);

    const value: AmplitudeContextType = { trackAmplitudeEvent };

    return <AmplitudeContext.Provider value={value}>{children}</AmplitudeContext.Provider>;
};

export default AmplitudeContextProvider;
